var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCheckmark24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_checkmark24x24",
    d: "M22.617,46.025a.735.735,0,0,0,.2-.135L33.761,35.863a.685.685,0,0,0,0-1.029l-.563-.516a.845.845,0,0,0-1.123,0l-9.815,9L17.9,39.336a.845.845,0,0,0-1.123,0l-.547.513a.685.685,0,0,0,0,1.029L21.7,45.89A.848.848,0,0,0,22.617,46.025Z",
    transform: "translate(-15.993 -34.103)",
    fill: "#999",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCheckmark24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_checkmark24x24.e0702b30b46a72ab15c438b9c63dc715.svg";